import { render } from "./CheckControllerAccessibility.vue?vue&type=template&id=63951eb9"
import script from "./CheckControllerAccessibility.vue?vue&type=script&lang=js"
export * from "./CheckControllerAccessibility.vue?vue&type=script&lang=js"
script.render = render

export default script